export default __webpack_public_path__ + "static/media/introduction_background.186a915b.jpg";